<template>
    <painel-component :items="itemsOne">
        <error-component v-if="showError" :errors="errors"/>

        <form v-if="showLoader">
            <row-component>
                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.type}">
                    <label>Entrada/Saída:</label>
                    <Multiselect v-model="formData.type" :options="selectEntranceExit" :searchable="true"
                                 :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.attended}">
                    <label>Antecipado:</label>
                    <Multiselect v-model="formData.attended" :options="selectYesNo" :searchable="true"
                                 :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.bank_accounts_id}">
                    <label>Conta Bancária:</label>
                    <Multiselect v-model="formData.bank_accounts_id" label="name" :options="selectBankAccountList"
                                 :searchable="true" :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.account_types_id}">
                    <label>Tipo de Conta:</label>
                    <Multiselect v-model="formData.account_types_id" :options="selectAccountTypeList"
                                 @select="selectAccountType(formData.account_types_id)" @clear="clearAccountType"
                                 :searchable="true" :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.account_type_sub_id}">
                    <label>Tipo de Sub Conta:</label>
                    <Multiselect v-model="formData.account_type_sub_id" :options="selectSubAccountTypeList"
                                 :disabled="disabled"
                                 :searchable="true" :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.price}">
                    <label>Valor:</label>
                    <input-component v-money="MONEY" v-model="formData.price" type-input="text"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                   :class="{'formError' : errors.obs}">
                    <label>Observações:</label>
                    <text-area v-model="formData.obs" :rows="5"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <button-submit class="w-100" :disabled="sendForm" @click="submit" name="Adicionar"
                                   icon="circle plus"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <button-route class="w-100" :items="itemsTwo"/>
                </row-col-component>
            </row-component>
        </form>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ErrorComponent from "@/components/alerts/ErrorComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import Multiselect from "@vueform/multiselect";
import InputComponent from "@/components/form/InputComponent";
import TextArea from "@/components/form/TextArea";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ButtonRoute from "@/components/buttons/ButtonRoute";

import {VMoney} from "v-money";
import {MONEY} from "@/configs/constants";
import {useToast} from "vue-toastification";

const toast = useToast()
export default {
    name: "EntranceExitCreate",
    components: {
        ButtonRoute,
        ButtonSubmit,
        TextArea,
        InputComponent,
        Multiselect,
        RowColComponent,
        RowComponent,
        ErrorComponent,
        PainelComponent
    },

    directives: {
        money: VMoney
    },

    created() {
        this.$store.dispatch("changeNamePage", "Entrada/Saída")
        this.$store.dispatch("loadBankAccountList")
        this.$store.dispatch("loadAccountTypeList")
        this.checkACL()
    },

    data() {
        return {
            itemsOne: {
                icon: "pen square",
                title: "Adicionar"
            },

            itemsTwo: {
                icon: "reply all",
                name: "Voltar",
                route: "/entrance-exit/search"
            },

            formData: {
                type: "",
                bank_accounts_id: "",
                account_types_id: "",
                price: "",
                business: "",
                attended: "",
                account_type_sub_id: "",
                obs: "",
            },

            MONEY,
            disabled: true,

            errors: [],
            sendForm: false,
            showError: false,
            showLoader: false,
        }
    },

    methods: {
        submit() {
            if (!this.sendForm) {
                this.sendForm = true;
                this.$store.dispatch('storeEntranceExit', this.formData)
                    .then(() => {
                        this.showError = false
                        this.sendForm = false
                        this.errors = []
                        toast.success("Entrada e saída criado com sucesso", {timeout: 1200});
                        this.$router.push({name: 'entrance-exit-search'})
                    }).catch((r) => {
                    this.showError = true;
                    this.sendForm = false
                    this.errors = r.response.data.errors;
                    window.scrollTo(0, 0)
                    toast.error("Seu formulário contém erros verificar!", {timeout: 2000});
                })
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLItemsNav')
                .then((r) => {
                    if (r.data.indexOf('entrance-exit-create') !== -1) {
                        this.showLoader = true
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        selectAccountType(id) {
            if (this.formData.account_types_id !== "") {
                this.disabled = false
                this.$store.dispatch("loadSubAccountTypeList", id)
            }
        },

        clearAccountType() {
            this.disabled = true
            this.formData.account_type_sub_id = ""
        }
    },

    computed: {
        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        selectBankAccountList() {
            return this.$store.state.var.selectBankAccountList
        },

        selectEntranceExit() {
            return this.$store.state.var.selectEntranceExit
        },

        selectAccountTypeList() {
            return this.$store.state.var.selectAccountTypeList
        },

        selectSubAccountTypeList() {
            return this.$store.state.var.selectSubAccountTypeList
        },

        selectYesNo() {
            return this.$store.state.var.selectYesNo
        },
    }
}
</script>